import { useEffect, useState } from 'react';
import { LoaderCircle } from 'lucide-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ensureSession, type SessionSnapshot } from './lib/api';
import { SyncProvider } from './lib/sync-context';
import { AppShell } from './components/AppShell';
import { CollaborationInvitePage } from './components/CollaborationInvitePage';

export default function App() {
  return (
    <Routes>
      <Route path="/collaborate/:token" element={<CollaborationInvitePage />} />
      <Route path="/*" element={<AuthenticatedWorkspace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function AuthenticatedWorkspace() {
  const [session, setSession] = useState<SessionSnapshot>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    void ensureSession()
      .then(setSession)
      .catch(cause => setError(cause instanceof Error ? cause.message : '无法连接 Aulivis'));
  }, []);

  if (error) {
    return (
      <main className="boot-error">
        <h1>暂时无法打开学习空间</h1>
        <p>{error}</p>
        <button className="primary-button" onClick={() => window.location.reload()}>重新连接</button>
      </main>
    );
  }
  if (!session) {
    return (
      <main className="boot-screen">
        <span className="boot-logo">AU</span>
        <LoaderCircle className="spin" />
        <p>正在打开你的学习空间…</p>
      </main>
    );
  }
  return (
    <SyncProvider userId={session.user.id}>
      <AppShell session={session} onSession={setSession} />
    </SyncProvider>
  );
}
